import type { SVGProps } from 'react'

// Matches the ord.net mark used by ordinalswallet.com's live activity feed.
export default function OrdNetIcon(props: SVGProps<SVGSVGElement>) {
	return <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
		<circle cx="16" cy="16" r="11.94" fill="none" stroke="#FF5000" strokeWidth="4.12" />
		<circle cx="16" cy="16" r="8.4" fill="#FF5000" />
	</svg>
}
